import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { pendingTasksReducer } from 'react-redux-spinner'
import app from './app'
import login from './login'

import auth from './reducers/auth'
import product from './reducers/product'
import cart from './reducers/cart'
import order from './reducers/order'
import storeAddress from './reducers/storeAddress'
import inventory from './reducers/inventory'
import promotions from './reducers/promotions'

export default combineReducers({
  routing: routerReducer,
  pendingTasks: pendingTasksReducer,
  app,
  login,
  auth,
  product,
  cart,
  order,
  storeAddress,
  inventory,
  promotions,
})



// WEBPACK FOOTER //
// ./src/ducks/index.js